import React, { cloneElement } from 'react';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import { useClipboard } from "../../../../hooks/use-clipboard.js";
import "../../../../utilities/color.js";
import 'date-fns';
import "../../../../utilities/locale.js";
import "../../../../hooks/use-prevent-keyboard-scrolling.js";
import "../../tooltip/hover-tooltip/hover-tooltip.js";
import 'classnames';
import "../../icon/font-icon/font-icon.js";
import 'react-laag';
import 'react-transition-group';
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import 'styled-components';
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import { StandardTooltip } from "../../tooltip/standard-tooltip/standard-tooltip.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
 * `<CopyButton>` is a wrapper component around any `<button>` component (such as `<StandardButton>` or `<IconButton>`)
 * that allows for copying string data to a users' clipboard via Clipboard API
 * and that shows a brief `<StandardTooltip>` message when copied successfully.
 *
 * This component assumes browser support for the [Clipboard API](https://developer.mozilla.org/en-US/docs/Web/API/Clipboard_API) `writeText` event.
 *
 * `id` prop is required and will be applied to your `<button>` component.
 * If your `<button>` needs to do `onClick` things in addition to copying, pass an `onClick` prop to
 * `<CopyButton onClick={() => {}}>` instead of your `<button>`.
 *
 * You can pass props to the `<StandardTooltip>` via the `tooltipProps` prop.
 * Some props won't be honored as they are internally controlled within this component
 * (`defaultOpen`, `id`, `openOnFocus`, `openOnHover`, and `tooltip`).
 *
 * If you need more control over the copy to clipboard experience, consider using
 * the `useClipboard` React hook with your own component.
 *
 * @param props CopyButtonProps
 * @returns FunctionComponent<CopyButtonProps>
 */
var CopyButton = function CopyButton(props) {
  var children = props.children,
    data = props.data,
    delay = props.delay,
    id = props.id,
    _onClick = props.onClick,
    tooltip = props.tooltip,
    tooltipProps = props.tooltipProps;
  var _useClipboard = useClipboard({
      delay: delay
    }),
    copied = _useClipboard.copied,
    copy = _useClipboard.copy;
  var tooltipId = "".concat(id, "-tooltip");
  return /*#__PURE__*/React.createElement(StandardTooltip, _extends({}, tooltipProps, {
    defaultOpen: copied || undefined,
    id: tooltipId,
    openOnFocus: false,
    openOnHover: false,
    tooltip: tooltip
  }), /*#__PURE__*/cloneElement(children, {
    id: id,
    onClick: function onClick(e) {
      copy(data);
      if (_onClick) {
        _onClick(e);
      }
    }
  }));
};
export { CopyButton };